<template>
    <div>
    <div elevation="0" color="transparent" flat>
      <div class="row mb-8">
        <div class="col-6 d-flex justify-content-start">
          <v-card-title>
            {{ $t('products.Status') }} {{productName ? "( " + productName + " )" : ''}}
          </v-card-title>
        </div>
        <div class="col-6 d-flex justify-content-end  gap-2">
        </div>
      </div>
    </div>
    <v-card elevation="0">

        <div v-if="loader" style="height: 200px; line-height: 250px;">
        <v-progress-circular indeterminate :size="50"></v-progress-circular>
    </div>
    <div class="ma-8">
        <!-- <div class="title-cadre mb-10">
            <div class="title">
                {{ $t('products.Status') }}
            </div>
        </div> -->

        <div class="timelineStatus my-2">

            <StatusButton disableIcon :title="statusTitle(0)"
            v-if="draftStatus != 4"  

                :color="draftStatus == 2 ? '#FF8934' : draftStatus == 1 ? '#00CBA0' : '#C5CDD4'"
                :style="Status < 0 ? 'color: black' : ''">
                <template v-slot:icon>
                    <svg v-if="Status > 0" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16.78 9.7L11.11 15.37C10.97 15.51 10.78 15.59 10.58 15.59C10.38 15.59 10.19 15.51 10.05 15.37L7.22 12.54C6.93 12.25 6.93 11.77 7.22 11.48C7.51 11.19 7.99 11.19 8.28 11.48L10.58 13.78L15.72 8.64C16.01 8.35 16.49 8.35 16.78 8.64C17.07 8.93 17.07 9.4 16.78 9.7Z"
                            fill="#FFFFFF" />
                    </svg>
                    <svg v-else-if="draftStatus == 2" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.4"
                            d="M12.0001 21.9999C16.7884 21.9999 20.6701 18.1182 20.6701 13.3299C20.6701 8.5416 16.7884 4.65991 12.0001 4.65991C7.21177 4.65991 3.33008 8.5416 3.33008 13.3299C3.33008 18.1182 7.21177 21.9999 12.0001 21.9999Z"
                            fill="#FFFFFF" />
                        <path
                            d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z"
                            fill="#FFFFFF" />
                        <path
                            d="M14.8906 3.45H9.11062C8.71062 3.45 8.39062 3.13 8.39062 2.73C8.39062 2.33 8.71062 2 9.11062 2H14.8906C15.2906 2 15.6106 2.32 15.6106 2.72C15.6106 3.12 15.2906 3.45 14.8906 3.45Z"
                            fill="#FFFFFF" />
                    </svg>
                    <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.4"
                            d="M12.0001 21.9999C16.7884 21.9999 20.6701 18.1182 20.6701 13.3299C20.6701 8.5416 16.7884 4.65991 12.0001 4.65991C7.21177 4.65991 3.33008 8.5416 3.33008 13.3299C3.33008 18.1182 7.21177 21.9999 12.0001 21.9999Z"
                            fill="#FFFFFF" />
                        <path
                            d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z"
                            fill="#FFFFFF" />
                        <path
                            d="M14.8906 3.45H9.11062C8.71062 3.45 8.39062 3.13 8.39062 2.73C8.39062 2.33 8.71062 2 9.11062 2H14.8906C15.2906 2 15.6106 2.32 15.6106 2.72C15.6106 3.12 15.2906 3.45 14.8906 3.45Z"
                            fill="#FFFFFF" />
                    </svg>
                </template>
            </StatusButton>
            <v-sheet  elevation="0" :height="5" :width="120"
            v-if="ToBeRectifiedStatus != 4"  
            :color="ToBeRectifiedStatus == 2 ? '#FF8934' : Status == 1 ? '#00CBA0' : '#C5CDD4'"

                style="margin: auto; margin-right: -20px; margin-left: -20px;"></v-sheet>
            <StatusButton disableIcon :title="statusTitle(2)"
             v-if="ToBeRectifiedStatus != 4"
           :color="ToBeRectifiedStatus == 2 ? '#FF8934' : Status == 1 ? '#00CBA0' : '#C5CDD4'"
            :style="Status == 8? '#F25C5C' :Status < 2 ? 'color:black' : ''">
                <template v-slot:icon>
                  
                    <svg v-if="ToBeRectifiedStatus != 2 " width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16.78 9.7L11.11 15.37C10.97 15.51 10.78 15.59 10.58 15.59C10.38 15.59 10.19 15.51 10.05 15.37L7.22 12.54C6.93 12.25 6.93 11.77 7.22 11.48C7.51 11.19 7.99 11.19 8.28 11.48L10.58 13.78L15.72 8.64C16.01 8.35 16.49 8.35 16.78 8.64C17.07 8.93 17.07 9.4 16.78 9.7Z"
                            fill="#FFFFFF" />
                    </svg>
                  
                    <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.4"
                            d="M12.0001 21.9999C16.7884 21.9999 20.6701 18.1182 20.6701 13.3299C20.6701 8.5416 16.7884 4.65991 12.0001 4.65991C7.21177 4.65991 3.33008 8.5416 3.33008 13.3299C3.33008 18.1182 7.21177 21.9999 12.0001 21.9999Z"
                            fill="#474F5A" />
                        <path
                            d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z"
                            fill="#474F5A" />
                        <path
                            d="M14.8906 3.45H9.11062C8.71062 3.45 8.39062 3.13 8.39062 2.73C8.39062 2.33 8.71062 2 9.11062 2H14.8906C15.2906 2 15.6106 2.32 15.6106 2.72C15.6106 3.12 15.2906 3.45 14.8906 3.45Z"
                            fill="#474F5A" />
                    </svg>
                </template>
            </StatusButton>


            <v-sheet  elevation="0" :height="5" :width="120"
            v-if="ToBeValidatedBySupplierStatus != 4 && ToBeValidatedBySupplierStatus !== undefined"

            :color="ToBeValidatedBySupplierStatus == 2 ? '#FF8934' : ToBeValidatedBySupplierStatus == 1 ? '#00CBA0' : '#C5CDD4'"

                style="margin: auto; margin-right: -20px; margin-left: -20px;"></v-sheet>
            <StatusButton disableIcon :title="statusTitle(3)"
            v-if="ToBeValidatedBySupplierStatus != 4 && ToBeValidatedBySupplierStatus !== undefined"

            :color="ToBeValidatedBySupplierStatus == 2 ? '#FF8934' : ToBeValidatedBySupplierStatus == 1 ? '#00CBA0' : '#C5CDD4'"
                :style="Status == 8? '#F25C5C' :Status < 2 ? 'color:black' : ''">
                <template v-slot:icon>
                  
                    <svg v-if="ToBeValidatedBySupplierStatus != 2" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16.78 9.7L11.11 15.37C10.97 15.51 10.78 15.59 10.58 15.59C10.38 15.59 10.19 15.51 10.05 15.37L7.22 12.54C6.93 12.25 6.93 11.77 7.22 11.48C7.51 11.19 7.99 11.19 8.28 11.48L10.58 13.78L15.72 8.64C16.01 8.35 16.49 8.35 16.78 8.64C17.07 8.93 17.07 9.4 16.78 9.7Z"
                            fill="#FFFFFF" />
                    </svg>
                    <svg v-else-if="ToBeValidatedBySupplierStatus == 2" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.4"
                            d="M12.0001 21.9999C16.7884 21.9999 20.6701 18.1182 20.6701 13.3299C20.6701 8.5416 16.7884 4.65991 12.0001 4.65991C7.21177 4.65991 3.33008 8.5416 3.33008 13.3299C3.33008 18.1182 7.21177 21.9999 12.0001 21.9999Z"
                            fill="#FFFFFF" />
                        <path
                            d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z"
                            fill="#FFFFFF" />
                        <path
                            d="M14.8906 3.45H9.11062C8.71062 3.45 8.39062 3.13 8.39062 2.73C8.39062 2.33 8.71062 2 9.11062 2H14.8906C15.2906 2 15.6106 2.32 15.6106 2.72C15.6106 3.12 15.2906 3.45 14.8906 3.45Z"
                            fill="#FFFFFF" />
                    </svg>
                    <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.4"
                            d="M12.0001 21.9999C16.7884 21.9999 20.6701 18.1182 20.6701 13.3299C20.6701 8.5416 16.7884 4.65991 12.0001 4.65991C7.21177 4.65991 3.33008 8.5416 3.33008 13.3299C3.33008 18.1182 7.21177 21.9999 12.0001 21.9999Z"
                            fill="#474F5A" />
                        <path
                            d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z"
                            fill="#474F5A" />
                        <path
                            d="M14.8906 3.45H9.11062C8.71062 3.45 8.39062 3.13 8.39062 2.73C8.39062 2.33 8.71062 2 9.11062 2H14.8906C15.2906 2 15.6106 2.32 15.6106 2.72C15.6106 3.12 15.2906 3.45 14.8906 3.45Z"
                            fill="#474F5A" />
                    </svg>
                </template>
            </StatusButton>
           
            <v-sheet elevation="0" :height="5" :width="120"
            v-if="ValidatedBySupplierStatus != 4 && ValidatedBySupplierStatus !== undefined"

            :color="ValidatedBySupplierStatus == 2 ? '#FF8934' : ValidatedBySupplierStatus == 1 ? '#00CBA0' : '#C5CDD4'"

                style="margin: auto; margin-right: -20px; margin-left: -20px;"></v-sheet>
            <StatusButton disableIcon :title="statusTitle(4)"
            v-if="ValidatedBySupplierStatus != 4 && ValidatedBySupplierStatus !== undefined"

            :color="ValidatedBySupplierStatus == 2 ? '#FF8934' : ValidatedBySupplierStatus == 1 ? '#00CBA0' : '#C5CDD4'"
                :style="Status == 3 ? '#F25C5C' :Status < 2 ? 'color:black' : ''">
                <template v-slot:icon>
                   
                    <svg v-if="ValidatedBySupplierStatus != 2" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16.78 9.7L11.11 15.37C10.97 15.51 10.78 15.59 10.58 15.59C10.38 15.59 10.19 15.51 10.05 15.37L7.22 12.54C6.93 12.25 6.93 11.77 7.22 11.48C7.51 11.19 7.99 11.19 8.28 11.48L10.58 13.78L15.72 8.64C16.01 8.35 16.49 8.35 16.78 8.64C17.07 8.93 17.07 9.4 16.78 9.7Z"
                            fill="#FFFFFF" />
                    </svg>
                    <svg v-else-if="ValidatedBySupplierStatus == 2" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.4"
                            d="M12.0001 21.9999C16.7884 21.9999 20.6701 18.1182 20.6701 13.3299C20.6701 8.5416 16.7884 4.65991 12.0001 4.65991C7.21177 4.65991 3.33008 8.5416 3.33008 13.3299C3.33008 18.1182 7.21177 21.9999 12.0001 21.9999Z"
                            fill="#FFFFFF" />
                        <path
                            d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z"
                            fill="#FFFFFF" />
                        <path
                            d="M14.8906 3.45H9.11062C8.71062 3.45 8.39062 3.13 8.39062 2.73C8.39062 2.33 8.71062 2 9.11062 2H14.8906C15.2906 2 15.6106 2.32 15.6106 2.72C15.6106 3.12 15.2906 3.45 14.8906 3.45Z"
                            fill="#FFFFFF" />
                    </svg>
                    <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.4"
                            d="M12.0001 21.9999C16.7884 21.9999 20.6701 18.1182 20.6701 13.3299C20.6701 8.5416 16.7884 4.65991 12.0001 4.65991C7.21177 4.65991 3.33008 8.5416 3.33008 13.3299C3.33008 18.1182 7.21177 21.9999 12.0001 21.9999Z"
                            fill="#474F5A" />
                        <path
                            d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z"
                            fill="#474F5A" />
                        <path
                            d="M14.8906 3.45H9.11062C8.71062 3.45 8.39062 3.13 8.39062 2.73C8.39062 2.33 8.71062 2 9.11062 2H14.8906C15.2906 2 15.6106 2.32 15.6106 2.72C15.6106 3.12 15.2906 3.45 14.8906 3.45Z"
                            fill="#474F5A" />
                    </svg>
                </template>
            </StatusButton>

            <v-sheet  elevation="0" :height="5" :width="120"
            v-if="ToBeValidatedStatus != 4 && ToBeValidatedStatus !== undefined"
            :color="ToBeValidatedStatus == 2 ? '#FF8934' : ToBeValidatedStatus == 1 ? '#00CBA0' : '#C5CDD4'"

                style="margin: auto; margin-right: -20px; margin-left: -20px;"></v-sheet>
            <StatusButton disableIcon :title="statusTitle(1)"
             v-if="ToBeValidatedStatus != 4 && ToBeValidatedStatus !== undefined"
             :color="ToBeValidatedStatus == 2 ? '#FF8934' : ToBeValidatedStatus == 1 ? '#00CBA0' : '#C5CDD4'"
             :style="Status == 8? '#F25C5C' :Status < 2 ? 'color:black' : ''">
                <template v-slot:icon>
                   
                    <svg v-if="ToBeValidatedStatus != 2" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16.78 9.7L11.11 15.37C10.97 15.51 10.78 15.59 10.58 15.59C10.38 15.59 10.19 15.51 10.05 15.37L7.22 12.54C6.93 12.25 6.93 11.77 7.22 11.48C7.51 11.19 7.99 11.19 8.28 11.48L10.58 13.78L15.72 8.64C16.01 8.35 16.49 8.35 16.78 8.64C17.07 8.93 17.07 9.4 16.78 9.7Z"
                            fill="#FFFFFF" />
                    </svg>
                    <svg v-else-if="ToBeValidatedStatus == 2" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.4"
                            d="M12.0001 21.9999C16.7884 21.9999 20.6701 18.1182 20.6701 13.3299C20.6701 8.5416 16.7884 4.65991 12.0001 4.65991C7.21177 4.65991 3.33008 8.5416 3.33008 13.3299C3.33008 18.1182 7.21177 21.9999 12.0001 21.9999Z"
                            fill="#FFFFFF" />
                        <path
                            d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z"
                            fill="#FFFFFF" />
                        <path
                            d="M14.8906 3.45H9.11062C8.71062 3.45 8.39062 3.13 8.39062 2.73C8.39062 2.33 8.71062 2 9.11062 2H14.8906C15.2906 2 15.6106 2.32 15.6106 2.72C15.6106 3.12 15.2906 3.45 14.8906 3.45Z"
                            fill="#FFFFFF" />
                    </svg>
                    <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.4"
                            d="M12.0001 21.9999C16.7884 21.9999 20.6701 18.1182 20.6701 13.3299C20.6701 8.5416 16.7884 4.65991 12.0001 4.65991C7.21177 4.65991 3.33008 8.5416 3.33008 13.3299C3.33008 18.1182 7.21177 21.9999 12.0001 21.9999Z"
                            fill="#474F5A" />
                        <path
                            d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z"
                            fill="#474F5A" />
                        <path
                            d="M14.8906 3.45H9.11062C8.71062 3.45 8.39062 3.13 8.39062 2.73C8.39062 2.33 8.71062 2 9.11062 2H14.8906C15.2906 2 15.6106 2.32 15.6106 2.72C15.6106 3.12 15.2906 3.45 14.8906 3.45Z"
                            fill="#474F5A" />
                    </svg>
                </template>
            </StatusButton>
            <v-sheet elevation="0" :height="5" :width="120"
             v-if="ValidatedStatus != 4 && ValidatedStatus !== undefined"
             :color="ValidatedStatus == 2 ? '#FF8934' : ValidatedStatus == 1 ? '#00CBA0' : '#C5CDD4'"

                style="margin: auto; margin-right: -20px; margin-left: -20px;"></v-sheet>
            <StatusButton disableIcon :title="statusTitle(5)"
            v-if="ValidatedStatus != 4 && ValidatedStatus !== undefined"

            :color="ValidatedStatus == 2 ? '#FF8934' : ValidatedStatus == 1 ? '#00CBA0' : '#C5CDD4'"
            :style="Status == 3 ? '#F25C5C' :Status < 2 ? 'color:black' : ''">
                <template v-slot:icon>
                   
                    <svg v-if="ValidatedStatus != 2" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16.78 9.7L11.11 15.37C10.97 15.51 10.78 15.59 10.58 15.59C10.38 15.59 10.19 15.51 10.05 15.37L7.22 12.54C6.93 12.25 6.93 11.77 7.22 11.48C7.51 11.19 7.99 11.19 8.28 11.48L10.58 13.78L15.72 8.64C16.01 8.35 16.49 8.35 16.78 8.64C17.07 8.93 17.07 9.4 16.78 9.7Z"
                            fill="#FFFFFF" />
                    </svg>
                    <svg v-else-if="ValidatedStatus == 2" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.4"
                            d="M12.0001 21.9999C16.7884 21.9999 20.6701 18.1182 20.6701 13.3299C20.6701 8.5416 16.7884 4.65991 12.0001 4.65991C7.21177 4.65991 3.33008 8.5416 3.33008 13.3299C3.33008 18.1182 7.21177 21.9999 12.0001 21.9999Z"
                            fill="#FFFFFF" />
                        <path
                            d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z"
                            fill="#FFFFFF" />
                        <path
                            d="M14.8906 3.45H9.11062C8.71062 3.45 8.39062 3.13 8.39062 2.73C8.39062 2.33 8.71062 2 9.11062 2H14.8906C15.2906 2 15.6106 2.32 15.6106 2.72C15.6106 3.12 15.2906 3.45 14.8906 3.45Z"
                            fill="#FFFFFF" />
                    </svg>
                    <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.4"
                            d="M12.0001 21.9999C16.7884 21.9999 20.6701 18.1182 20.6701 13.3299C20.6701 8.5416 16.7884 4.65991 12.0001 4.65991C7.21177 4.65991 3.33008 8.5416 3.33008 13.3299C3.33008 18.1182 7.21177 21.9999 12.0001 21.9999Z"
                            fill="#474F5A" />
                        <path
                            d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z"
                            fill="#474F5A" />
                        <path
                            d="M14.8906 3.45H9.11062C8.71062 3.45 8.39062 3.13 8.39062 2.73C8.39062 2.33 8.71062 2 9.11062 2H14.8906C15.2906 2 15.6106 2.32 15.6106 2.72C15.6106 3.12 15.2906 3.45 14.8906 3.45Z"
                            fill="#474F5A" />
                    </svg>
                </template>
            </StatusButton>

          
            


            <v-sheet
            v-if="ActivatedStatus != 4 || DeactivatedStatus != 4"

    elevation="0"
    :height="5"
    :width="120"
    :color="ActivatedStatus == 2 ? '#00CBA0' : DeactivatedStatus == 2 ? '#F25C5C' : '#C5CDD4'"
    style="margin: auto; margin-right: -20px; margin-left: -20px;">
</v-sheet>

<StatusButton
v-if="ActivatedStatus != 4 || DeactivatedStatus != 4"
  disableIcon
    :title="ActivatedStatus == 2 ? statusTitle(6) : DeactivatedStatus == 2 ? statusTitle(7) : statusTitle(6)"
    :color="ActivatedStatus == 2 ? '#00CBA0' : DeactivatedStatus == 2 ? '#F25C5C' : '#C5CDD4'"
    :style="Status == 7 ? 'color:black;' : Status == 6 ? 'color:black;' : 'color:black;'">
    <template v-slot:icon>
        <svg v-if="ActivatedStatus == 2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16.78 9.7L11.11 15.37C10.97 15.51 10.78 15.59 10.58 15.59C10.38 15.59 10.19 15.51 10.05 15.37L7.22 12.54C6.93 12.25 6.93 11.77 7.22 11.48C7.51 11.19 7.99 11.19 8.28 11.48L10.58 13.78L15.72 8.64C16.01 8.35 16.49 8.35 16.78 8.64C17.07 8.93 17.07 9.4 16.78 9.7Z"
                fill="#FFFFFF" />
        </svg>
        <svg v-else-if="DeactivatedStatus == 2" width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.7998 0.5C3.6673 0.5 0.299805 3.8675 0.299805 8C0.299805 12.1325 3.6673 15.5 7.7998 15.5C11.9323 15.5 15.2998 12.1325 15.2998 8C15.2998 3.8675 11.9323 0.5 7.7998 0.5ZM10.3198 9.725C10.5373 9.9425 10.5373 10.3025 10.3198 10.52C10.2073 10.6325 10.0648 10.685 9.9223 10.685C9.7798 10.685 9.6373 10.6325 9.5248 10.52L7.7998 8.795L6.0748 10.52C5.9623 10.6325 5.8198 10.685 5.6773 10.685C5.5348 10.685 5.3923 10.6325 5.2798 10.52C5.0623 10.3025 5.0623 9.9425 5.2798 9.725L7.0048 8L5.2798 6.275C5.0623 6.0575 5.0623 5.6975 5.2798 5.48C5.4973 5.2625 5.8573 5.2625 6.0748 5.48L7.7998 7.205L9.5248 5.48C9.7423 5.2625 10.1023 5.2625 10.3198 5.48C10.5373 5.6975 10.5373 6.0575 10.3198 6.275L8.59481 8L10.3198 9.725Z"
                fill="white" />
        </svg>
        <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.4"
                d="M12.0001 21.9999C16.7884 21.9999 20.6701 18.1182 20.6701 13.3299C20.6701 8.5416 16.7884 4.65991 12.0001 4.65991C7.21177 4.65991 3.33008 8.5416 3.33008 13.3299C3.33008 18.1182 7.21177 21.9999 12.0001 21.9999Z"
                fill="#474F5A" />
            <path
                d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 12.41 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z"
                fill="#474F5A" />
            <path
                d="M14.8906 3.45H9.11062C8.71062 3.45 8.39062 3.13 8.39062 2.73C8.39062 2.33 8.71062 2 9.11062 2H14.8906C15.2906 2 15.6106 2.32 15.6106 2.72C15.6106 3.12 15.2906 3.45 14.8906 3.45Z"
                fill="#474F5A" />
        </svg>
    </template>
</StatusButton>





            <v-sheet elevation="0" :height="5" :width="120"
            v-if="Status == 8"
            :color="Status == 8 ? '#F25C5C' : Status == 2 ? '#FF8934' : Status > 3 ? '#00CBA0' : '#C5CDD4'"

                style="margin: auto; margin-right: -20px; margin-left: -20px;"></v-sheet>
            <StatusButton disableIcon :title="statusTitle(8)"
              v-if="Status == 8"
              :color="Status == 8 ? '#F25C5C' : Status == 2 ? '#FF8934' : Status > 3 ? '#00CBA0' : '#C5CDD4'"
              :style="Status == 3 ? '#F25C5C' :Status < 2 ? 'color:black' : ''">
                <template v-slot:icon>
                    <svg v-if="Status == 8 " width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.7998 0.5C3.6673 0.5 0.299805 3.8675 0.299805 8C0.299805 12.1325 3.6673 15.5 7.7998 15.5C11.9323 15.5 15.2998 12.1325 15.2998 8C15.2998 3.8675 11.9323 0.5 7.7998 0.5ZM10.3198 9.725C10.5373 9.9425 10.5373 10.3025 10.3198 10.52C10.2073 10.6325 10.0648 10.685 9.9223 10.685C9.7798 10.685 9.6373 10.6325 9.5248 10.52L7.7998 8.795L6.0748 10.52C5.9623 10.6325 5.8198 10.685 5.6773 10.685C5.5348 10.685 5.3923 10.6325 5.2798 10.52C5.0623 10.3025 5.0623 9.9425 5.2798 9.725L7.0048 8L5.2798 6.275C5.0623 6.0575 5.0623 5.6975 5.2798 5.48C5.4973 5.2625 5.8573 5.2625 6.0748 5.48L7.7998 7.205L9.5248 5.48C9.7423 5.2625 10.1023 5.2625 10.3198 5.48C10.5373 5.6975 10.5373 6.0575 10.3198 6.275L8.59481 8L10.3198 9.725Z" fill="white" />
                    </svg>
                    <svg v-else-if="Status > 3" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16.78 9.7L11.11 15.37C10.97 15.51 10.78 15.59 10.58 15.59C10.38 15.59 10.19 15.51 10.05 15.37L7.22 12.54C6.93 12.25 6.93 11.77 7.22 11.48C7.51 11.19 7.99 11.19 8.28 11.48L10.58 13.78L15.72 8.64C16.01 8.35 16.49 8.35 16.78 8.64C17.07 8.93 17.07 9.4 16.78 9.7Z"
                            fill="#FFFFFF" />
                    </svg>
                    <svg v-else-if="Status == 2" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.4"
                            d="M12.0001 21.9999C16.7884 21.9999 20.6701 18.1182 20.6701 13.3299C20.6701 8.5416 16.7884 4.65991 12.0001 4.65991C7.21177 4.65991 3.33008 8.5416 3.33008 13.3299C3.33008 18.1182 7.21177 21.9999 12.0001 21.9999Z"
                            fill="#FFFFFF" />
                        <path
                            d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z"
                            fill="#FFFFFF" />
                        <path
                            d="M14.8906 3.45H9.11062C8.71062 3.45 8.39062 3.13 8.39062 2.73C8.39062 2.33 8.71062 2 9.11062 2H14.8906C15.2906 2 15.6106 2.32 15.6106 2.72C15.6106 3.12 15.2906 3.45 14.8906 3.45Z"
                            fill="#FFFFFF" />
                    </svg>
                    <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.4"
                            d="M12.0001 21.9999C16.7884 21.9999 20.6701 18.1182 20.6701 13.3299C20.6701 8.5416 16.7884 4.65991 12.0001 4.65991C7.21177 4.65991 3.33008 8.5416 3.33008 13.3299C3.33008 18.1182 7.21177 21.9999 12.0001 21.9999Z"
                            fill="#474F5A" />
                        <path
                            d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z"
                            fill="#474F5A" />
                        <path
                            d="M14.8906 3.45H9.11062C8.71062 3.45 8.39062 3.13 8.39062 2.73C8.39062 2.33 8.71062 2 9.11062 2H14.8906C15.2906 2 15.6106 2.32 15.6106 2.72C15.6106 3.12 15.2906 3.45 14.8906 3.45Z"
                            fill="#474F5A" />
                    </svg>
                </template>
            </StatusButton>

       
        </div>

        <!-- Boutons de validation -->
        <div  class="my-8 row justify-content-center"> 
            <div class="col-8 justify-content-center">
                <div  class="row justify-content-center">
                    <div  class="col-auto">
                        <genericBtnComponent v-if="affichReviseButton"  backgroundColor="#FFDF00" @click="dialogCommentRectify = true"
                            :Title="$t('products.RectifyBtn')" width="150" />
                    </div>
                    <div class="col-auto">
                        <genericBtnComponent v-if="affichValidationButton" backgroundColor="#114EF7" @click="dialogValidate = true"
                            :Title="$t('products.ValidateBtn')" width="150">
                            <template v-slot:logo>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.4"
                                        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                        fill="#FFFFFF" />
                                    <path
                                        d="M10.5795 15.5801C10.3795 15.5801 10.1895 15.5001 10.0495 15.3601L7.21945 12.5301C6.92945 12.2401 6.92945 11.7601 7.21945 11.4701C7.50945 11.1801 7.98945 11.1801 8.27945 11.4701L10.5795 13.7701L15.7195 8.6301C16.0095 8.3401 16.4895 8.3401 16.7795 8.6301C17.0695 8.9201 17.0695 9.4001 16.7795 9.6901L11.1095 15.3601C10.9695 15.5001 10.7795 15.5801 10.5795 15.5801Z"
                                        fill="#FFFFFF" />
                                </svg>
                            </template>
                        </genericBtnComponent>
                    </div>
                    <div  class="col-auto">
                        <genericBtnComponent v-if="affichRejectButton" backgroundColor="#F25C5C" @click="dialogCommentRefus = true"
                            :Title="$t('clients.validationTab.refuseBtn')" width="150" />
                    </div>

                    <div class="col-auto">
                        <genericBtnComponent v-if="affichSendForValidationButton" backgroundColor="#00CBA0" @click="dialogSendForValidation = true"
                            :Title="$t('products.sendForValidation')" width="190">
                            <template v-slot:logo>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.4"
                                        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                        fill="#FFFFFF" />
                                    <path
                                        d="M10.5795 15.5801C10.3795 15.5801 10.1895 15.5001 10.0495 15.3601L7.21945 12.5301C6.92945 12.2401 6.92945 11.7601 7.21945 11.4701C7.50945 11.1801 7.98945 11.1801 8.27945 11.4701L10.5795 13.7701L15.7195 8.6301C16.0095 8.3401 16.4895 8.3401 16.7795 8.6301C17.0695 8.9201 17.0695 9.4001 16.7795 9.6901L11.1095 15.3601C10.9695 15.5001 10.7795 15.5801 10.5795 15.5801Z"
                                        fill="#FFFFFF" />
                                </svg>
                            </template>
                        </genericBtnComponent>
                    </div>
                    <div class="col-auto">
                        <genericBtnComponent v-if="affichPublishButton" backgroundColor="#00CBA0" @click="dialogPublish = true"
                            :Title="$t('products.Publish')" width="160">
                            <template v-slot:logo>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.4"
                                        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                        fill="#FFFFFF" />
                                    <path
                                        d="M10.5795 15.5801C10.3795 15.5801 10.1895 15.5001 10.0495 15.3601L7.21945 12.5301C6.92945 12.2401 6.92945 11.7601 7.21945 11.4701C7.50945 11.1801 7.98945 11.1801 8.27945 11.4701L10.5795 13.7701L15.7195 8.6301C16.0095 8.3401 16.4895 8.3401 16.7795 8.6301C17.0695 8.9201 17.0695 9.4001 16.7795 9.6901L11.1095 15.3601C10.9695 15.5001 10.7795 15.5801 10.5795 15.5801Z"
                                        fill="#FFFFFF" />
                                </svg>
                            </template>
                        </genericBtnComponent>
                    </div>

                   
                    <div class="col-auto">
                        <genericBtnComponent v-if="affichActivateButton" backgroundColor="#00CBA0" @click="dialogActivation = true"
                            :Title="$t('products.Activate')" width="160">
                            <template v-slot:logo>
                                <svg  width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.4"
                                        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                        fill="#FFFFFF" />
                                    <path
                                        d="M10.5795 15.5801C10.3795 15.5801 10.1895 15.5001 10.0495 15.3601L7.21945 12.5301C6.92945 12.2401 6.92945 11.7601 7.21945 11.4701C7.50945 11.1801 7.98945 11.1801 8.27945 11.4701L10.5795 13.7701L15.7195 8.6301C16.0095 8.3401 16.4895 8.3401 16.7795 8.6301C17.0695 8.9201 17.0695 9.4001 16.7795 9.6901L11.1095 15.3601C10.9695 15.5001 10.7795 15.5801 10.5795 15.5801Z"
                                        fill="#FFFFFF" />
                                </svg>
                             </template>
                            
                        </genericBtnComponent>
                    </div>

                    <div class="col-auto">
                        <genericBtnComponent v-if="affichDeactivateButton" backgroundColor="#F25C5C" @click="dialogDeactivation = true"
                            :Title="$t('products.Deactivate')" width="160">
                            <template v-slot:logo>
                                <svg  width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.7998 0.5C3.6673 0.5 0.299805 3.8675 0.299805 8C0.299805 12.1325 3.6673 15.5 7.7998 15.5C11.9323 15.5 15.2998 12.1325 15.2998 8C15.2998 3.8675 11.9323 0.5 7.7998 0.5ZM10.3198 9.725C10.5373 9.9425 10.5373 10.3025 10.3198 10.52C10.2073 10.6325 10.0648 10.685 9.9223 10.685C9.7798 10.685 9.6373 10.6325 9.5248 10.52L7.7998 8.795L6.0748 10.52C5.9623 10.6325 5.8198 10.685 5.6773 10.685C5.5348 10.685 5.3923 10.6325 5.2798 10.52C5.0623 10.3025 5.0623 9.9425 5.2798 9.725L7.0048 8L5.2798 6.275C5.0623 6.0575 5.0623 5.6975 5.2798 5.48C5.4973 5.2625 5.8573 5.2625 6.0748 5.48L7.7998 7.205L9.5248 5.48C9.7423 5.2625 10.1023 5.2625 10.3198 5.48C10.5373 5.6975 10.5373 6.0575 10.3198 6.275L8.59481 8L10.3198 9.725Z"
                fill="white" />
        </svg>
                    
                            </template>
                        </genericBtnComponent>
                    </div>
                </div>
            </div>
        </div>

        <!-- Historique de validation -->
        <div v-if="validationHistory.length" class="title-cadre mt-10 mb-4">
            <div class="title">
                {{ $t('suppliers.validationTab.validationHistory') }}
            </div>
        </div>
        <v-table fixed-header height="200px">
            <thead>
                <tr>
                    <th class="text-center">     {{ $t('clients.validationTab.StatusChangedDate') }}</th>
                    <th class="text-center">validated By</th>
                    <th class="text-center">{{ $t('clients.validationTab.status') }}</th>
                    <th class="text-center">{{ $t('clients.validationTab.commentaire') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="entry in validationHistory" :key="entry.id">
                    <td>{{ formatDate(entry.validationDate) }}</td>
                    <td style="text-wrap: nowrap">
                    <v-list-item-title v-text="entry.validatedBy.fullName"></v-list-item-title>
                    <v-list-item-subtitle v-text="entry.validatedBy.email"></v-list-item-subtitle>
                </td>
                    <td><StatusButton :title="entry.status"  :color="statusColor(entry.status)" /></td>
                    <td style="min-width: 200px;" >{{ entry.comment }}</td>
                    
                </tr>
            </tbody>
        </v-table>

        <!-- Dialogs de validation, rectification, rejet, publication -->
        <dialogDelete :loader="buttonLoader" DialogType="Validation" :title="$t('products.product')" :yes="validateProduct" v-model="dialogValidate" ></dialogDelete>
        <dialogDelete :loader="buttonLoader" DialogType="Refuse" :title="$t('products.product')" :yes="rejectProduct" v-model="dialogReject" />
        <dialogDelete :loader="buttonLoader" DialogType="ToCorrect" :title="$t('products.product')" :yes="rectifyProduct" v-model="dialogRectify" />
        <dialogDelete :loader="buttonLoader" DialogType="SendValidation" :title="$t('products.product')" :yes="SendValidation" v-model="dialogSendForValidation" />
        <dialogDelete :loader="buttonLoader" DialogType="Status" :title="$t('products.product')" :status="null" :yes="ActiveProduct" v-model="dialogActivation" />
        <dialogDelete :loader="buttonLoader" DialogType="Status" :title="$t('products.product')" :status="!null" :yes="ActiveProduct" v-model="dialogDeactivation" />
        <dialogDelete :loader="buttonLoader" DialogType="Validation" :title="$t('products.product')"  :yes="PublishProduct" v-model="dialogPublish" />


        <v-dialog v-model="dialogCommentRectify" v-if="dialogCommentRectify">
            <v-card width="max-content" height="max-content" class="px-8 py-4">
                <div class="row justify-content-center">
                    <v-card-title class="text-left">{{ $t('products.validationTab.commentaireRectify') }} : <span
                            class="red">*</span>
                    </v-card-title>
                </div>
                <div class="row justify-content-center">
                    <v-textarea id="Comment" v-model="rectificationComment" variant="outlined" counter
                        :label="$t('products.validationTab.commentaireLabel')" single-line auto-grow hide-details
                        maxlength="500"></v-textarea>
                    <span class="warningHint" id="WarningMsgComment">{{ msg.comment }}</span>
                </div>
                <div class="row justify-content-center">
                    <card-actions :yes="checkCommentRectification" v-model:no="dialogCommentRectify" width="200px"
                        :yesTitle="$t('products.validationTab.rectifyBtn')" :YesColor="'#F25C5C'" />
                </div>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogCommentRefus" v-if="dialogCommentRefus">
            <v-card width="max-content" height="max-content" class="px-8 py-4">
                <div class="row justify-content-center">
                    <v-card-title class="text-left">{{ $t('products.validationTab.commentaire') }} : <span
                            class="red">*</span>
                    </v-card-title>
                </div>
                <div class="row justify-content-center">
                    <v-textarea id="Comment" v-model="rejectedComment" variant="outlined" counter
                        :label="$t('products.validationTab.commentaireLabel')" single-line auto-grow hide-details
                        maxlength="500"></v-textarea>
                    <span class="warningHint" id="WarningMsgComment">{{ msg.comment }}</span>
                </div>
                <div class="row justify-content-center">
                    <card-actions :yes="checkCommentRefuse" v-model:no="dialogCommentRefus" width="200px"
                        :yesTitle="$t('products.validationTab.refuseBtn')" :YesColor="'#F25C5C'" />
                </div>
            </v-card>
        </v-dialog>
    </div>
    </v-card>
  </div>
  
</template>

<script>
import { getProductById, PublishProduct ,ToValidateProduct, RejectProduct, RectifyProduct, ValidateProduct, GetProductValidationTrace ,GetProductStatus, ChangeStatusOfProductById } from "@/api";
import StatusButton from "@/genericComponent/StatusButton.vue";
import genericBtnComponent from "@/genericComponent/genericBtnComponent.vue";
import dialogDelete from "@/genericComponent/dialogDelete.vue";
import cardActions from "@/genericComponent/cardActions.vue"

export default {
    components: { StatusButton, genericBtnComponent, dialogDelete, cardActions },
    data() {
        return {
            rejectedComment: '', // Commentaire pour le refus
            rectificationComment: '', // Commentaire pour la révision
            afficheCommentaireRefuse: false, // Contrôle l'affichage du champ de commentaire pour le refus
            afficheCommentaireRectification: true, // Contrôle l'affichage du champ de commentaire pour la révision


            loader: true,
            affichPublishButton:false,
            affichSendForValidationButton:false,
            affichActivateButton: false,
            affichDeactivateButton: false,
            affichValidationButton: false,
            affichReviseButton: false,
            affichRejectButton: false,
            dialogSendForValidation: false,
            dialogValidate: false,
            dialogReject: false,
            dialogRectify: false,
            dialogActivation: false,
            dialogDeactivation: false,
            dialogPublish: false,

            ActivatedStatus: null,
            DeactivatedStatus: null,
            draftStatus: null,
            RefusedStatus: null,
            ToBeRectifiedStatus: null,
            ToBeValidatedStatus: null,
            ValidatedStatus: null,
            ValidatedBySupplierStatus:null,
            ToBeValidatedBySupplierStatus:null,

            msg:[],
            comment: "",
            buttonLoader: false,
            validationHistory: [],
            Status : 0,
            idProduct: this.$route.params.id,

            productName: '', 
            dialogCommentRectify: false,
            dialogCommentRefus: false,
        };
    },
    created() {
        this.loadProductValidation(this.idProduct);
        this.GetProductStatus(this.idProduct);
    },
    async mounted() {
        const item = await this.GetProductById(this.$route.params.id);
        this.productName = item;
    },
    methods: {
        async GetProductById(productId) {
            let item = null;
            await getProductById(productId).then(({ data }) => {
                item = data.name;
            });
            return item;
        },
        GetProductStatus(idProduct){
            GetProductStatus(idProduct).then((response) =>
                {
                    this.Status = response.data
                }   
            ) 
        },
        async loadProductValidation(id) {
            this.loader = true;
            try {
                const response = await GetProductValidationTrace(id);
                //this.Status = response.data.status;

                this.affichActivateButton=response.data.buttonsStates.CanActivate;
                this.affichDeactivateButton=response.data.buttonsStates.CanDeactivate;
                this.affichPublishButton=response.data.buttonsStates.CanPublish;

                this.affichSendForValidationButton=response.data.buttonsStates.CanSendForValidation;
                this.affichValidationButton = response.data.buttonsStates.CanValidate;
                this.affichReviseButton = response.data.buttonsStates.CanRevise;
                this.affichRejectButton = response.data.buttonsStates.CanRefuse;
                this.validationHistory = response.data.traceValidationList;
                this.draftStatus = response.data.validationStates.Draft
                this.ActivatedStatus= response.data.validationStates.Activated
                this.DeactivatedStatus= response.data.validationStates.Deactivated
                this.RefusedStatus= response.data.validationStates.Refused
                this.ToBeRectifiedStatus= response.data.validationStates.ToBeRectified
                this.ToBeValidatedStatus= response.data.validationStates.ToBeValidated
                this.ValidatedStatus= response.data.validationStates.Validated
                this.ValidatedBySupplierStatus=response.data.validationStates.ValidatedBySupplier
                this.ToBeValidatedBySupplierStatus=response.data.validationStates.ToBeValidatedBySupplier

            } catch (error) {
                console.error("Failed to load product validation trace:", error);
            } finally {
                this.loader = false;
            }
        },
        async validateProduct() {
            this.buttonLoader = true;
            try {
                 ValidateProduct(this.idProduct);
                 await this.loadProductValidation(this.idProduct);
                 await  this.GetProductStatus(this.idProduct);
                 this.Status = 5;
            } finally {
                this.GetProductStatus(this.idProduct);
                this.affichValidationButton= false;
                this.dialogValidate = false;
                this.buttonLoader = false;
                this.loadProductValidation(this.idProduct);
            }
        },
        async rejectProduct() {
            this.buttonLoader = true;
            try {
                await RejectProduct(this.idProduct, this.rejectedComment);
                await this.loadProductValidation(this.idProduct);
                await    this.GetProductStatus(this.idProduct);
            } finally {
                this.dialogReject = false;
                this.dialogCommentRefus = false;
                this.buttonLoader = false;
                await this.loadProductValidation(this.idProduct);
                await    this.GetProductStatus(this.idProduct);
            }
        },

        async rectifyProduct() {
            this.buttonLoader = true;
            try {
                await RectifyProduct(this.idProduct,this.rectificationComment);
                await this.loadProductValidation(this.idProduct);
                await    this.GetProductStatus(this.idProduct);
            } finally {
                this.dialogRectify = false;
                this.dialogCommentRectify = false;
                this.buttonLoader = false;
                this.affichValidationButton = false ;
                await this.loadProductValidation(this.idProduct);
                await    this.GetProductStatus(this.idProduct);
            }
        },


        async SendValidation() {
            this.buttonLoader = true;
            try {
                ToValidateProduct(this.idProduct);
                await this.loadProductValidation(this.idProduct);
                await    this.GetProductStatus(this.idProduct);
            } finally {
                this.dialogSendForValidation = false;
                this.affichSendForValidationButton = false;
                this.buttonLoader = false;
                await this.loadProductValidation(this.idProduct);
                await    this.GetProductStatus(this.idProduct);
            
            }
        },
        async ActiveProduct() {
            this.buttonLoader = true;
            try {
                ChangeStatusOfProductById(this.idProduct)
                await this.loadProductValidation(this.idProduct);
                await    this.GetProductStatus(this.idProduct);
           
            } finally {
                this.dialogActivation = false;
                this.dialogDeactivation = false;
                this.buttonLoader = false;
              this.GetProductById(this.idProduct); 
              await this.loadProductValidation(this.idProduct);
              await    this.GetProductStatus(this.idProduct);
             }
        },
        async PublishProduct() {
            this.buttonLoader = true;
            try {
                PublishProduct(this.idProduct)
                this.loadProductValidation(this.idProduct);
                await this.loadProductValidation(this.idProduct);
                await    this.GetProductStatus(this.idProduct);

            } finally {
                this.dialogPublish = false;
                this.ActivatedStatus=1

                this.buttonLoader = false;
                await this.loadProductValidation(this.idProduct);
                await    this.GetProductStatus(this.idProduct);

            }
        },
        formatDate(date) {
            return new Date(date).toLocaleString();
        },
        OpenCommentRejected() {
            this.afficheCommentaireRefuse = true;
            this.afficheCommentaireRectification = false;
        },
        OpenCommentRectification() {
            this.afficheCommentaireRefuse = false;
            this.afficheCommentaireRectification = true;
        },
        checkCommentRefuse() {
            if (!this.rejectedComment || this.rejectedComment.trim() === '') {
                this.msg['comment'] = this.$t('warningInput.isrequired', {
                    itm: this.$t('products.validationTab.commentaire'),
                });
            } else {
                this.dialogReject = true;
            }
        },
        checkCommentRectification() {
            if (!this.rectificationComment || this.rectificationComment.trim() === '') {
                this.msg['comment'] = this.$t('warningInput.isrequired', {
                    itm: this.$t('products.validationTab.commentaire'),
                });
            } else {
                this.dialogRectify = true;
            }
        },
        statusTitle(option) {
    switch (option) {
        case 0: return this.$t('common.Draft');
            case 1: return this.$t('common.ToBeValidated');
            case 2: return this.$t('common.ToBeRectified'); 
            case 3: return this.$t('common.ToBeValidatedBySupplier'); 
            case 4: return this.$t('common.ValidatedBySupplier'); 
            case 5: return this.$t('common.Validated');
            case 6: return this.$t('common.active');
            case 7: return this.$t('common.inactive');
            case 8: return this.$t('common.Refused');
    }
},
statusColor(option) {
    switch (option) {
        case 0: return "#BEBEBE"; 
        case 1: return "#FF8934"; 
        case 2: return "#FFDF00"; 
        case 3: return "#FF8934"; 
        case 4: return "#00CBA0"; 
        case 5: return "#00CBA0"; 
    }
}
    }
};
</script>
